(function($) {

function mobileNav() {
        "use strict";
        var toggled = false;
        $('.toggle-icon').on('click', function (e) {
            e.preventDefault();
            if (!toggled) {
                toggled = true;
                $('.mobile-nav-container').addClass('toggled');
            } else {
                toggled = false;
                $('.mobile-nav-container').removeClass('toggled');
            }
        });

        $(window).on('resize', function () {
            var width = $(window).width();
            if (width > 768) {
                toggled = false;
                $('.mobile-nav-container').removeClass('toggled');
            }
        });
    }

    function getNavColor(bgColor, direction) {
        if (bgColor == 'rgb(19, 66, 107)') {
            $('#navigation').addClass('blue');
            $('#navigation').removeClass('white');
            $('#navigation').removeClass('grey');
        } else if (bgColor == 'rgb(255, 255, 255)') {
            $('#navigation').removeClass('blue');
            $('#navigation').addClass('white');
            $('#navigation').removeClass('grey');
        } else if (bgColor == 'rgb(248, 248, 248)') {
            $('#navigation').removeClass('blue');
            $('#navigation').removeClass('white');
            $('#navigation').addClass('grey');
        } else if (direction == 'down') {
            //do nothing
        } else {
            $('#navigation').removeClass('blue');
            $('#navigation').removeClass('white');
            $('#navigation').removeClass('grey');
        }
    }

    function fullpageInit() {
        var isTouch = (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0));
        if (isTouch) {
            var optionDisablePointer = false;
        } else {
            var optionDisablePointer = true;
        }
        $('#fullpage').fullpage({
            menu: true,
            fitToSection: false,
            scrollOverflow: true,
            recordHistory: false,
            scrollOverflowOptions: {
                disablePointer: optionDisablePointer
            },
            dragAndMove: false,
            onLeave: function (index, nextIndex, direction) {
                $(".section-nav li").removeClass('active');
                if (direction == 'down' && (nextIndex - index == 1)) {
                    /* Tests to see if you are scrolling. Opposed to clicking side nav */
                    var bgColor = $('.fp-section.active').next().css("background-color");
                    getNavColor(bgColor, direction);
                }
                if (direction == 'up' && (nextIndex - index == -1)) {
                    /* Tests to see if you are scrolling. Opposed to clicking side nav */
                    var bgColor = $('.fp-section.active').prev().css("background-color");
                    getNavColor(bgColor, direction);
                }
            },
            afterLoad: function (anchorLink) {
                var current = $(".section-nav").find("[data-menuanchor='" + anchorLink + "']");
                current.addClass('active');

                var bgColor = $('.fp-section.active').css("background-color"); // Required for page pageload - styles nav to current section onload
                getNavColor(bgColor, 'down');
            }
        });
    }

    function pageNav() {
        var str = '';
        str += '<ul class="section-nav">';
        $(".section[data-anchor]").each(function () {
            var slug = $(this).data('anchor');
            var name = $(this).data('name');
            if (slug && name) {
                str += '<li data-menuanchor="' + slug + '"><a href="#' + slug + '">' + name + '</a></li>';
            }
        });
        str += '</ul>';
        $('.side-navigation').html(str);
    }

    function reclinerInit() {
        $(".recliner").recliner({
            attrib: "data-src", // selector for attribute containing the media src
            throttle: 300, // millisecond interval at which to process events
            threshold: 100, // scroll distance from element before its loaded
            live: true // auto bind lazy loading to ajax loaded elements
        });
    }

    $(document).ready(function () {
        mobileNav();
        pageNav();
        fullpageInit();
        reclinerInit();
    });

    $(document).on('click', '.section-nav li a', function (e) {
        var anchor = $(this).parent().data('menuanchor');
        var bgColor = $(".section[data-anchor='" + anchor + "']").css("background-color");
        getNavColor(bgColor, null);
    });

})( jQuery );